import { Buffer } from "buffer";

(<any>window).Buffer = Buffer;